import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import isEmpty from 'lodash/fp/isEmpty';
import { pure } from '@dbk/ui-react-utils';

import Text, { Large, H1 } from '../../../../components/common/text';
import TableRow from '../../../../components/common/table-row';
import { Currency } from '../../../../components/common/number';

import { factory } from '../../transactions/position-header/position-header-container';

import styles from './cash-transactions-header.styles';

function CashTransactionsHeader(props) {
  const { labels = {}, position = {}, referenceCurrency, messages } = props;

  if (isEmpty(position)) {
    return <View><Text>{messages['app.common.loadingText']}</Text></View>;
  }

  return (
    <View style={styles.container} testID="position-header">
      <H1 secondary>{messages["app.common.pageTitle.transactions"]}</H1>
      {/* <Large style={styles.securityName} testID="position-header-label">
        {position.securityName}
      </Large> */}
      <View style={styles.transactionSummary}>
        <TableRow>
          <TableRow.Column 
            align="right" 
            testID="position-header-item-label" 
            width="auto">
            <Text style={styles.label} testID="position-header-item-label">{messages['app.common.portfolio.bonds.account']}</Text>
          </TableRow.Column>
          <TableRow.Column 
            gutter={false} 
            testID="position-header-item-value"
            width="auto">
            <Large testID="position-header-item-value"> {position.account} </Large>
          </TableRow.Column>
        </TableRow>

        <TableRow>
          <TableRow.Column
            align="right"
            testID="position-header-item-label"
            width="auto">
            <Text style={styles.label} testID="position-header-item-label">{messages['app.common.portfolio.bonds.balance']}</Text>
          </TableRow.Column>
          <TableRow.Column
            gutter={false}
            testID="position-header-item-value"
            wrap={false}
            width="auto">
            <Currency
              renderProps={{
                size: 'large',
                testID: 'position-header-item-value',
              }}
              value={position.balance}
              currency={position.positionCurrency}
              signBeforeNumber={false}
            />
          </TableRow.Column>
        </TableRow>
        <TableRow>
          <TableRow.Column
            align="rights"
            testID="position-header-item-label"
            width="auto">
            <Text
              style={styles.label}
              testID="position-header-item-label"
            >{messages['app.common.portfolio.bonds.balRef']}</Text>
          </TableRow.Column>
          <TableRow.Column
            gutter={false}
            testID="position-header-item-value"
            wrap={false}
            width="auto">
            <Text style={styles.value} testID="position-header-item-value">
              <Currency
                renderProps={{
                  size: 'large',
                }}
                value={position.marketValue}
                currency={position.marketValueUnit}
                signBeforeNumber={false}
              />
            </Text>
          </TableRow.Column>
        </TableRow>
      </View>
    </View>
  );
}

CashTransactionsHeader.propTypes = {
  position: PropTypes.shape({
    account: PropTypes.string.isRequired,
    balance: PropTypes.number.isRequired,
    marketValue: PropTypes.number.isRequired,
  }),
  labels: PropTypes.shape({
    account: PropTypes.string.isRequired,
    balance: PropTypes.string.isRequired,
    ledgerBalance: PropTypes.string.isRequired,
  }),
  referenceCurrency: PropTypes.string,
};

export default factory({
  component: pure(CashTransactionsHeader),
  positionDataFragmentExtend: {
    account: true,
    balance: true,
  },
});
